export function getRoleHome(role) {
    switch (role) {
        case 'superadmin':
            return '/superadmin/respondentsRegistry';
        case 'admin':
            return '/admin/reports/registry';
        case 'legalentityowner':
        case 'legal_entity_owner':
        case 'leg_entity_owner':
            return '/legalEntityOwner/sign';
        case 'respondent':
            return '/participant/outcome/required';
        case 'integration':
            return '/integration';
        case 'monitor':
            return '/monitor/forms';
        default:
            return '/';
    }
}
